import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { ImageField } from 'shared/react-admin/Fields';
import { getColumnStyle } from 'utils';

export const DatagridConfigurableStyled = styled(DatagridConfigurable)(({ theme }) => ({
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  '.RaDatagrid-headerCell': {
    backgroundColor: theme.palette.tableHead,
    padding: '8px 16px',
    lineHeight: '18px',
  },
  '.MuiTableCell-root': {
    verticalAlign: 'middle',
  },
  '.MuiTableCell-body': {
    padding: '8px 16px',
  },
  '& .resize-impactToBalance': getColumnStyle(135),
  '& .resize-id': getColumnStyle(122),
  '& .resize-createdAt': getColumnStyle(114),
  '& .resize-updatedAt': getColumnStyle(130),
  '& .resize-status': getColumnStyle(134),
  '& .resize-currency': getColumnStyle(84),
  '& .resize-merchant': getColumnStyle(102),
  '& .resize-gateway': getColumnStyle(116),
  '& .resize-method': getColumnStyle(195),
  '& .resize-merchantReference': getColumnStyle(153),
  '& .resize-providerReferenceId': getColumnStyle(150),
  '& .resize-amount': {
    ...getColumnStyle(170),
    textAlign: 'right',
    flexDirection: 'row',
  },
  '& .column-commissionValueByCurrencyOrder': {
    ...getColumnStyle(140),
    textAlign: 'right',
  },
  '& .column-commissionValueByCurrencyCommission': {
    ...getColumnStyle(135),
    textAlign: 'right',
  },
  '& .resize-totalAmount': {
    ...getColumnStyle(143),
    textAlign: 'right',
  },
  '& .resize-commission': getColumnStyle(177),
  '& .resize-merchantAccount': {
    ...getColumnStyle(205),
  },
}));

export const ImageFieldStyled = styled(ImageField)({
  '& .RaImageField-image': {
    margin: 0,
    marginRight: '2px',
    maxWidth: 24,
    maxHeight: 24,
    minWidth: 24,
    minHeight: 24,
    objectFit: 'contain',
  },
});

export const BoxStyled = styled(Box)(({ theme }) => ({
  height: '64px',
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
  border: `1px solid ${theme.palette.divider}`,
  borderBottom: 0,
  padding: '0 16px',
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.background.default,
}));
